import { Injectable } from "@angular/core";
import { ApiHandler } from "@app/shared/services/api-handler.service";
import { Observable } from "rxjs/Observable";
import { DashboardService } from "@app/admin/dashboard/service/dashboard.service";

@Injectable()
export class DonutChartService {
  constructor(public apiHandler: DashboardService) {}

  getEarnings() {
    const earnings = this.apiHandler.getIncomeDistribution().map(res => {
      let changedObj = [];

      const earnings = res["data"];
      // console.log("earnings", earnings);

      function getLabelObj(label: string, value: string) {
        return { label: label, value: parseFloat(value) };
      }

      changedObj.push(
        getLabelObj("Driver Earnings", earnings["driver_earning"])
      );
      changedObj.push(getLabelObj("TAXIWHEELEarnings", earnings["six_earning"]));
      changedObj.push(
        getLabelObj("Referral Commission", earnings["referral_commission"])
      );
      changedObj.push(
        getLabelObj("Referral Bonus", earnings["referral_bonus"])
      );
      changedObj.push(getLabelObj("Admin Fees", earnings["admin_fees"]));

      return changedObj;
    });

    return earnings;
  }
}

const EARNINGS = {
  driver_earning: 60,
  admin_fees: 7,
  referral_bonus: 8,
  referral_commission: 10,
  six_earning: 15
};



// WEBPACK FOOTER //
// ./src/app/shared/component/donut-chart/donut-chart.service.ts